/**
 * @author - steves165
 */

(function() {
    'use strict';

    /*global angular, vhols*/
    angular.module('vhols')

        .constant('EMPTY', '')

        .directive('touchHover', function() {
            var _HOVER_CONTENT_CLASS = 'hover-content';
            var _IS_TOUCH = 'ontouchstart' in document.documentElement;

            return function($scope, $element) {
                if (_IS_TOUCH) {
                    $element.on('click', function() {
                        $element.toggleClass(_HOVER_CONTENT_CLASS);
                    });
                } else {
                    $element.on('mouseover', function() {
                        $element.addClass(_HOVER_CONTENT_CLASS);
                    });

                    $element.on('mouseout', function() {
                        $element.removeClass(_HOVER_CONTENT_CLASS);
                    });
                }
            };
        })

        .directive('scrollTo', ['anchorSmoothScroll',
            function(anchorSmoothScroll) {
                return {
                    restrict: 'A',
                    link: function(scope, $element, $attrs) {
                        var idToScroll = $attrs.ngHref.replace('#', '');

                        $element.on('click', function(e) {
                            e.stopPropagation();
                            anchorSmoothScroll.scrollTo(idToScroll);
                        });
                    }
                };
            }
        ])

        /**
         * This is for tracking functions it takes a node array string splits it by &&&
         * then it splits individual string by the first = then sets the attribute of index 0
         * equal to index 1.
         */
        .directive('clickAttr', function() {
            return {
                replace: false,
                link: function($scope, $element, $attrs) {
                    var clickAttrArr = $attrs.clickAttr.split('&&&');

                    function attrAttach(clickAttr) {
                        var clickAttrs = clickAttr.split(/=(.+)?/);
                        $element.attr(clickAttrs[0], clickAttrs[1]);
                    }

                    if (typeof clickAttrArr === 'string') {
                        attrAttach(clickAttrArr);
                    } else {
                        clickAttrArr.forEach(function(clickAttr) {
                            attrAttach(clickAttr);
                        });
                    }
                }
            };
        })

        .directive('localTime', ['moment', function(moment) {
            return {
                replace: true,
                scope: {
                    timeZone: '@'
                },
                link: function($scope) {
                    var zone = moment().tz($scope.timeZone);
                    var utcOffset = zone.utcOffset();
                    var localDateAtDestination = moment().utcOffset(utcOffset);

                    $scope.aheadBehind = utcOffset < 0 ? '-' : '+';
                    $scope.hours = Math.abs((moment.tz($scope.timeZone).utcOffset() - moment().utcOffset()) / 60);
                    $scope.time = localDateAtDestination.format('hh:mma');
                    $scope.currdate = localDateAtDestination.format('Do MMM YYYY');

                    setTimeout(function update() {
                        var localDateAtDestination = moment().utcOffset(utcOffset);
                        $scope.time = localDateAtDestination.format('hh:mma');
                        $scope.currdate = localDateAtDestination.format('Do MMM YYYY');
                        $scope.$apply();
                        setTimeout(update, 60000);
                    }, 60000);
                },
                templateUrl: 'template/directives/localTime.html'
            };
        }])

        .directive('hotelSortOrder', function() {
            var options = [{
                "name": "Sort by: We recommend",
                "value": "",
                "selected": true
            },
                {
                    "name": "Sort by: Name asc",
                    "value": "hotel.content.name",
                    "selected": false
                },
                {
                    "name": "Sort by: Name desc",
                    "value": "-hotel.content.name",
                    "selected": false
                },
                {
                    "name": "Sort by: V Rating asc",
                    "value": "hotel.content.vRating",
                    "selected": false
                },
                {
                    "name": "Sort by: V Rating desc",
                    "value": "-hotel.content.vRating",
                    "selected": false
                }];

            return {
                replace: true,
                restrict: "E",
                link: function($scope, $element, $attrs) {
                    $scope.options = options;
                    var handleFakeNull = $attrs.defaultorder === 'null' ? '' : $attrs.defaultorder;
                    $scope.wtsOrder = handleFakeNull;
                },
                template: '<select class="form-control" id="qa-wts-sort-by" ng-model="wtsOrder" ng-options="option.value as option.name for option in options"></select>'
            };
        })

        /**
         * The link to view all hotels in a destinations. Replaces -holidays with -hotels and removes vhols root node.
         */
        .directive('viewHotelsLink', ['$window', function($window) {
            var path = window.location.pathname.replace('/vhols', '');
            var hotels = path.replace('-holidays', '-hotels');

            return {
                link: function($scope) {
                    var holidayTypesHotelsLink = window.location.href.replace(/overview/, 'hotels');
                    $scope.link = $window.ngVariables.HOLIDAY_TYPES ? holidayTypesHotelsLink : hotels;

                    $scope.$root.$on('hotelCount', function($event, $attr) {
                        $scope.$evalAsync(function() {
                            $scope.hotelCount = parseInt($attr) > 1 ? ('all ' + $attr + ' hotels') : ($attr + ' hotel');
                        });
                    });
                },
                replace: true,
                template: '<a href="{{link}}" class="button button-secondary">View {{hotelCount}}</a>'
            };
        }])

        /**
         * On change of select box it fires the changeDestination function.
         */
        .directive('destinationChange', function() {
            return {
                replace: false,
                link: function($scope, $element, $attrs) {
                    $scope.destinationSelectEvents = $attrs.destinationChange;
                    $scope.changeDestination(true);

                    $element.on('change', function() {
                        if ($element.val() !== '') {
                            var selectedIndex = $element[0].selectedIndex;
                            $scope.selectedDestinationName = $element[0][selectedIndex].text;
                            $scope.destinationSelectEvents = $element.val();
                            $scope.changeDestination();
                        }
                    });
                }
            };
        })

        .directive('calendarSwitch', function() {
            return {
                replace: false,
                scope: {
                    calendarSwitch: '@'
                },
                link: function($scope, $element) {
                    setTimeout(function() {
                        var content = angular.element(document.getElementById($scope.calendarSwitch));
                        var cal = angular.element(document.getElementsByClassName('events-cal-view'));

                        if (content.text().replace(/\s/g, '').length > 0) {
                            $element.on('click', function() {
                                cal.addClass('hide');
                                $element.parent().parent().find('button').removeClass('btn-active');
                                content.removeClass('hide');
                                $element.addClass('btn-active');
                            });
                        } else {
                            $element.addClass('disabled');
                        }

                        var cont = true;

                        angular.forEach(cal, function(item) {
                            if (angular.element(item).text().replace(/\s/g, '').length > 0 && cont) {
                                angular.element(document.getElementById(item.getAttribute('id') + '-btn')).triggerHandler('click');
                                cont = !cont;
                            }
                        });
                    }, 100);
                }
            };
        })

        .directive('excursionsList', ["excursionsService", function(excursionsService) {
            return {
                require: '^scrollArea',
                scope: {
                    order: '=',
                    telephoneNumber: '@',
                    locationId: '@',
                    brandId: '@'
                },
                controller: function($scope) {
                    var startingArray = [];
                    $scope.hide = false;

                    excursionsService.getExcursions($scope.locationId, $scope.brandId).then(function(results) {
                        startingArray.push(results);

                        $scope.excursions = (function excurse($scope, location, arr) {
                            var result = arr ? arr : [];

                            location.map(function(data) {
                                if (data.metadata) {
                                    data.metadata.forEach(function(excursion) {
                                        result.push({
                                            name: excursion.name,
                                            location: data.description,
                                            description: excursion.description
                                        });
                                    });
                                }

                                if (data.children !== null) {
                                    excurse($scope, data.children, result);
                                }
                            });

                            return result;
                        })($scope, startingArray);
                    }, function(error) {
                        $scope.hide = true;
                    });

                },
                link: function($scope, $element, $attrs, ScrollArea) {
                    $scope.scrollArea = ScrollArea;

                    var section = vhols.getClosest($element[0], '.destination-section');
                    var heading = section.getElementsByClassName('section-title');
                    var $headingParagraph = angular.element(heading).find('p');

                    $scope.$watch('excursions', function() {
                        if ($scope.excursions) {
                            ScrollArea.$scope.maxWidth();
                            $headingParagraph.append('<small class="section-counter">(' + $scope.excursions.length + ')</small>');
                        }
                    });

                    $scope.$watch('hide', function() {
                        if ($scope.hide) {
                            angular.element(section).remove();
                        }
                    });
                },
                templateUrl: 'template/directives/excursions-list.html'
            };
        }])

        .directive('whereToStayList', ['$window', function($window) {
            return {
                require: '^scrollArea',
                scope: {
                    order: '=',
                    collection: '=',
                    locationId: '@',
                    brandId: '@',
                    isEdit: '@'
                },
                link: function($scope, $element, $attrs, ScrollArea) {
                    var wanger = $element.find('svg');
                    var section = vhols.getClosest($element[0], '.destination-section');

                    $scope.$watch('collection', function() {
                        if ($scope.collection) {
                            if ($scope.collection.length > 0) {
                                wanger.remove();

                                $scope.$root.$broadcast('hotelCount', $scope.collection.length);

                                $scope.collection.forEach(function(holiday) {
                                    holiday.hotel.content.finalLink = window.ngVariables.HOLIDAY_TYPES ? $window.location.pathname.replace(/overview/, 'hotels/' + holiday.hotel.content.urlName) : '/destinations' + holiday.hotel.content.url + '-browse';
                                });
                            }

                            $scope.$evalAsync(function() {
                                ScrollArea.$scope.maxWidth();
                            });
                        }
                    });

                    $scope.$watch('hide', function() {
                        if ($scope.hide && $scope.isEdit !== 'true') {
                            angular.element(section).remove();

                            var $sections = angular.element(document.getElementsByClassName('destination-section'));

                            $sections.removeClass('bg-teal');
                            $sections.removeClass('bg-white');

                            angular.forEach($sections, function(currSection, $index) {
                                var $section = angular.element(currSection);

                                $section.addClass((($index - 1) % 2) ? 'bg-white' : 'bg-teal');
                            });
                        }
                    });
                },
                templateUrl: 'template/directives/where-to-stay-list.html'
            };
        }])

        .directive('countButton', function() {
            var _DESTINATIONS_IN = '/destinations-in';

            function pluraise(count, singular) {
                return ' ' + (count === 1 ? singular : singular + 's');
            }

            return {
                scope: {
                    countElements: '@',
                    countedSingular: '@'
                },
                link: function($scope, $element) {
                    var count = document.getElementsByClassName($scope.countElements).length;
                    var counted = pluraise(count, $scope.countedSingular);

                    $scope.count = count + counted;
                    $scope.link = location.href + _DESTINATIONS_IN;
                },
                template: '<a class="button button-secondary" href="{{link}}">View all {{count}}</a>'
            };
        })

        .directive('retrieveHolidays', ['hotelsService', function(hotelsService) {
            return {
                link: function($scope, $element) {
                    $scope.hotels = [];

                    hotelsService.getHotels().then(function(result) {
                        $scope.hotels = result;
                    }, function(error) {
                        console.error('No hotels found');
                    });
                }
            };
        }])

        .directive("tourDatepickerModal", ["$modal", function($modal) {
            return {
                restrict: 'A',
                link: function($scope, element, $attrs) {
                    var params = {
                        tourId: $attrs.tourId,
                        urlFriendlyId: $attrs.urlFriendlyId,
                        regionUrlValue: $attrs.regionUrlValue
                    };
                    $scope.open = function() {
                        var modalInstance = $modal.open({
                            controller: 'HolidayDatepickerCtrl',
                            windowClass: 'tourDatepickerModal',
                            templateUrl: 'template/tourDatepickerModal.html',
                            resolve: {
                                params: function() {
                                    return params;
                                }
                            }
                        });
                    };
                }
            };
        }])

        .directive("cruiseDatepickerModal", ["$modal", function($modal) {
            return {
                restrict: 'A',
                link: function($scope, element, $attrs) {
                    var params = {
                        cruiseId: $attrs.cruiseId,
                        urlFriendlyId: $attrs.urlFriendlyId,
                        regionUrlValue: $attrs.regionUrlValue
                    };
                    $scope.open = function() {
                        var modalInstance = $modal.open({
                            controller: 'HolidayDatepickerCtrl',
                            windowClass: 'cruiseDatepickerModal',
                            templateUrl: 'template/cruiseDatepickerModal.html',
                            resolve: {
                                params: function() {
                                    return params;
                                }
                            }
                        });
                    };
                }
            };
        }])

        .controller('HolidayDatepickerCtrl', ["$scope", "$modalInstance", "params", function ($scope, $modalInstance, params) {
            $scope.params = params;
            $scope.close = function (e) {
                $modalInstance.close();
            };
        }])

        .directive("searchModal", ["$modal", "$window", "$rootScope", '$timeout', function($modal, $window, $rootScope, $timeout) {

            return {
                restrict: "E",
                link: function($scope, $element, $attr) {
                    var searchPanel = parseInt($attr.searchPanel, 10),
                        mdLocation = $attr.location || false;

                    $scope.open = function () {

                        var $body = angular.element($window.document.querySelector("body")),
                            windowTop = -1 * ($window.pageYOffset || $window.document.documentElement.scrollTop),
                            windowTopStyle = 'top:' + windowTop + 'px;';

                        $body.attr('style', windowTopStyle);

                        var criteria = {
                            selectedBookingType: {
                                brand: 205,
                                id: searchPanel
                            }
                        };

                        if(mdLocation) {
                            criteria.selectedChildLocation = {
                                locationUrlDescription: mdLocation.split('|').pop()
                            };
                        }

                        var modalInstance = $modal.open({
                            size: 'lg',
                            controller: 'StickyModalCtrl',
                            windowTopClass: 'searchModal',
                            templateUrl: 'template/search-modal.html'
                        });

                        modalInstance.opened.then(function () {
                            $timeout(function() {
                                $rootScope.$emit('SearchPanel:populate', criteria);
                            },0,false);
                        });
                    };
                },
                templateUrl: 'template/search-modal-cta.html'
            };
        }])


        .controller('StickyModalCtrl', ["$window", "$scope", "$modalInstance", function ($window, $scope, $modalInstance) {
            var disposable = $scope.$on("$destroy", function() {
                var $body = angular.element($window.document.querySelector("body")),
                    bodyTop = Math.abs(parseInt($body.css("top")));
                $body.removeClass("modal-open");
                $body.removeAttr("style");
                $window.scrollTo(0, bodyTop);
                disposable();
            });
            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }]);
})();
